var _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsWithbackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 38 \\u2013 75",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 47",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#5300f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 529",
    d: "M21.752 15.2v-2.54l-2.083-.412a5.811 5.811 0 00-.453-1.09l1.162-1.741-1.79-1.795-1.748 1.162a5.809 5.809 0 00-1.09-.453l-.41-2.083H12.8l-.412 2.083a5.811 5.811 0 00-1.09.453L9.557 7.622 7.762 9.417l1.162 1.743a5.811 5.811 0 00-.453 1.088l-2.083.412v2.54l2.083.41a5.812 5.812 0 00.453 1.09l-1.162 1.748 1.795 1.79 1.743-1.162a5.811 5.811 0 001.088.453l.41 2.083h2.542l.41-2.083a5.81 5.81 0 001.09-.453l1.748 1.162 1.79-1.79-1.162-1.743a5.811 5.811 0 00.453-1.09zm-2.532 3.128l-.751.751-1.6-1.066a5.243 5.243 0 01-1.893.786l-.377 1.912H13.54l-.377-1.912a5.243 5.243 0 01-1.893-.786l-1.6 1.066-.751-.751 1.066-1.6a5.243 5.243 0 01-.786-1.893l-1.911-.375V13.4l1.912-.377a5.247 5.247 0 01.788-1.893l-1.066-1.6.751-.751 1.597 1.069a5.243 5.243 0 011.893-.786l.377-1.914h1.06l.377 1.912a5.243 5.243 0 011.893.786l1.6-1.066.751.751-1.066 1.6a5.245 5.245 0 01.786 1.893l1.912.377v1.06l-1.912.377a5.241 5.241 0 01-.786 1.893z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 530",
    d: "M14.07 11.08a2.85 2.85 0 102.85 2.85 2.853 2.853 0 00-2.85-2.85zm0 4.885a2.035 2.035 0 112.035-2.035 2.038 2.038 0 01-2.035 2.035z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWithbackground);
export default __webpack_public_path__ + "static/media/settings-withbackground.1c8607d1b75cc25a173769b1c52d5ab1.svg";
export { ForwardRef as ReactComponent };